import { atom } from 'jotai';
import { atomWithSuspenseQuery } from 'jotai-tanstack-query';
import { TeamWithRels } from '@statsbomb/parachute-types';
import { fetchClientAtom } from './client';

// This query atom used to be defined in atoms/queries/teams.ts, but it was moved here to avoid circular dependencies.
const rawAllTeamsAtom = atomWithSuspenseQuery(get => ({
  queryKey: ['allTeams'],
  queryFn: async () => {
    const { fetch } = get(fetchClientAtom);
    return (await fetch(`/teams`)) as Promise<TeamWithRels[]>;
  },
}));

export const allTeamsAtom = atom(async get => {
  const rawAllTeams = (await get(rawAllTeamsAtom)).data;
  return rawAllTeams;
});
